import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "px-7 py-5" }
const _hoisted_8 = { class: "row mb-8" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "row mb-12" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Government", -1)
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = ["label"]
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "row mb-8" }
const _hoisted_19 = { class: "row mb-12" }
const _hoisted_20 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = { class: "row mb-12" }
const _hoisted_23 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = ["label"]
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-8 fv-row" }
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_32 = { class: "col-lg-8 fv-row" }
const _hoisted_33 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_34 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_35 = { class: "badge badge-light-success fs-6" }
const _hoisted_36 = {
  key: 1,
  class: "d-flex justify-content-center py-10"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 2,
  class: "text-center py-10 text-muted fs-6"
}
const _hoisted_40 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  type: "button",
  class: "btn btn-light-success btn-sm me-2"
}
const _hoisted_43 = { class: "svg-icon svg-icon-2" }
const _hoisted_44 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_45 = { class: "indicator-label" }
const _hoisted_46 = { class: "indicator-progress" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_vue3_json_excel = _resolveComponent("vue3-json-excel")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'reports'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('registeredTradesTopAreasReports')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _withModifiers(_ctx.onSubmitCreate, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control form-control-sm form-control-solid",
                          placeholder: _ctx.translate('From'),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.dateFrom) = $event))
                        }, null, 8, _hoisted_10), [
                          [_vModelText, _ctx.selectedItems.dateFrom]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control form-control-sm form-control-solid",
                          placeholder: _ctx.translate('To'),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItems.dateTo) = $event))
                        }, null, 8, _hoisted_12), [
                          [_vModelText, _ctx.selectedItems.dateTo]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select form-select-sm form-select-solid",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedItems.govIds) = $event))
                      }, [
                        _createElementVNode("option", {
                          selected: "",
                          disabled: "",
                          label: _ctx.translate('selectGovernment'),
                          value: ""
                        }, null, 8, _hoisted_16),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.govs, (gov) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: gov.id,
                            value: gov.id
                          }, _toDisplayString(gov.titleAr), 9, _hoisted_17))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.selectedItems.govIds]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.translate('Property Status')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedItems.selectedPropertyStatus,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedItems.selectedPropertyStatus) = $event)),
                          mode: "tags",
                          requierd: false,
                          label: "description_ar",
                          trackBy: "description_ar",
                          searchable: true,
                          canDeselect: true,
                          options: _ctx.registeredTradesDesc,
                          placeholder: _ctx.translate('selectPropertyStatus'),
                          valueProp: "description_ar",
                          noResultsText: _ctx.translate('noResultsFound')
                        }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("label", _hoisted_23, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.translate('selectPropertyGrouping')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedItems.propertyGroupingId) = $event)),
                          class: "form-select form-select-sm form-select-solid"
                        }, [
                          _createElementVNode("option", {
                            label: _ctx.translate('selectPropertyGrouping'),
                            disabled: "",
                            value: ""
                          }, null, 8, _hoisted_25),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyGroupings, (grouping) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: grouping.id,
                              value: grouping.id
                            }, _toDisplayString(grouping.titleAr), 9, _hoisted_26))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.selectedItems.propertyGroupingId]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("label", _hoisted_28, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.translate('status')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedItems.status,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedItems.status) = $event)),
                          mode: "tags",
                          searchable: true,
                          canDeselect: true,
                          options: _ctx.statusOptions,
                          placeholder: _ctx.translate('selectStatus'),
                          valueProp: "value",
                          label: "label",
                          trackBy: "label",
                          noResultsText: _ctx.translate('noResultsFound')
                        }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("label", _hoisted_31, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('statusNotes')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedItems.statusNotesIds,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedItems.statusNotesIds) = $event)),
                        mode: "tags",
                        searchable: true,
                        canDeselect: true,
                        options: _ctx.statusNotesOptions,
                        placeholder: _ctx.translate('selectStatusNotes'),
                        valueProp: "value",
                        label: "label",
                        trackBy: "label",
                        noResultsText: _ctx.translate('noResultsFound')
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                    ])
                  ]),
                  (_ctx.showExportBtn && _ctx.data && _ctx.data.data && _ctx.data.data.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.translate('NumOfData')) + ": " + _toDisplayString(_ctx.data.data.length), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
                    : _createCommentVNode("", true),
                  (
                _ctx.hasQueried &&
                !_ctx.isLoading &&
                (!_ctx.data || !_ctx.data.data || _ctx.data.data.length === 0)
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.translate('noDataFound')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                (_ctx.showExportBtn && _ctx.data && _ctx.data.data && _ctx.data.data.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                      _createVNode(_component_vue3_json_excel, {
                        "json-data": _ctx.data.data,
                        fields: _ctx.excelHeader,
                        header: _ctx.excelHeaderRows,
                        worksheet: "Registered Trades Top Areas WorkSheet",
                        name: 
                'Registered_Trades_TOP_AREAS_' +
                'Reports_' +
                new Date().toISOString().slice(0, 10) +
                '.xls'
              
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", _hoisted_42, [
                            _createElementVNode("span", _hoisted_43, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil009.svg" })
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.translate('export')), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["json-data", "fields", "header", "name"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light-danger btn-sm me-3",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
                }, _toDisplayString(_ctx.translate('resetFilters')), 1),
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('back')), 1),
                _createElementVNode("button", _hoisted_44, [
                  _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.translate('query')), 1),
                  _createElementVNode("span", _hoisted_46, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_47
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ])
      ]))
    : _createCommentVNode("", true)
}